import { render, staticRenderFns } from "./AssessmentParametersPane.vue?vue&type=template&id=54d29c36&"
import script from "./AssessmentParametersPane.vue?vue&type=script&lang=ts&"
export * from "./AssessmentParametersPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports